export default {_name:'text.block',module:'Field',view:'Element/Text/Block',options:{variant:'body1',color:'textPrimary'}}